import firebase from "firebase/compat/app"
import "firebase/compat/auth"
import "firebase/compat/firestore"
import "firebase/compat/storage"

const config = {
    apiKey: process.env.REACT_APP_FIREBASE_apiKey,
    authDomain: process.env.REACT_APP_FIREBASE_authDomain,
    projectId: process.env.REACT_APP_FIREBASE_projectId,
    storageBucket: process.env.REACT_APP_FIREBASE_storageBucket,
    messagingSenderId: process.env.REACT_APP_FIREBASE_messagingSenderId,
}

if (process.env.REACT_APP_FIREBASE_appId) {
    config.appId = process.env.REACT_APP_FIREBASE_appId
}

if (process.env.REACT_APP_FIREBASE_databaseURL) {
    config.databaseURL = process.env.REACT_APP_FIREBASE_databaseURL
}

firebase.initializeApp(config)

export default firebase

export const getFirebaseInvisibleRecaptcha = (containerId, callback = () => {}) => {
    // Return existing instance if it's already instantiated
    if (window.recaptchaVerifier) {
        return window.recaptchaVerifier
    }

    // Otherwise, create it ONCE and save it
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(containerId, {
        size: "invisible",
        callback: callback,
    })

    return window.recaptchaVerifier
}
